import React, { useState } from 'react';
import Select from "react-select";
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Card, CardBody } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import ServerTable from "../../../lib/ServerTable";
import getPetrolBunkColumns from "./columns/PetrolBunkColumns";
import { useAuth, useApiDelete } from "../../../hooks";
import { ConfirmModal, SuccessToolbar, ErrorToolbar } from "../../../lib/formControls";
import filterIcon from "../../../common/images/filter.png";

const formInitailData = {
    planId: null,
    subscriberId: null,
    paymentStatus: null,
    subscriptionStatus: null,
  };

export default function PetrolBunkList() {
  const [formData, setFormData] = useState(formInitailData);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showFilder, setShowFilder] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState('');
  const [customSearch, setCustomSearch] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);
  const [customerror, setCustomerror] = useState('');
  const [tableKey, setTableKey] = useState(0);
  const { authToken } = useAuth();
  const { deleteData, loading, error } = useApiDelete('entities',authToken);

  const navigate = useNavigate();
   
  const handleDelete = (roleId) => {
        setShowConfirm(true);
        setSelectedRowId(roleId);
  };

  const handleViewDetail = (rowDetails) => {
        navigate(`/bunk/view/${rowDetails.id}`);
  };

  const handleConfirm = async () => {
    setIsDeleted(false);
    let payloadObj = { id: selectedRowId };
    let payload = JSON.stringify(payloadObj);
    const { result, error } = await deleteData(payload);
    
    if(error) {
      setCustomerror(error);
    } else {
      setIsDeleted(true);
      setTableKey(prevKey => prevKey + 1);
    }

    setShowConfirm(false);
    setSelectedRowId('');
  };

  const handleCancel = () => {
    setShowConfirm(false);
    setSelectedRowId('');
  };

  const handleDetailCancel = () => {
    setShowDetails(false);
    setRowData([]);
  };

  const handleSearchChange = (e) => {
    setCustomSearch(e.target.value);
  };

  const handleEditBunk = (row) => {
        /*navigate('/bunk/add');*/
        window.location.href = '/bunk/edit/'+row.id;
  }

  const columns = getPetrolBunkColumns(handleDelete, handleViewDetail, handleEditBunk);

  const handleChange = (selectedOption, actionMeta) => {
    setFormData(prev => ({
      ...prev,
      [actionMeta.name]: selectedOption
    }));
  };

  const handleAddBunk = () => {
        /*navigate('/bunk/add');*/
        window.location.href = '/bunk/add';
  }

  

  const paymentStatusOptions = [
    { value: true, label: "Paid" },
    { value: false, label: "Unpaid" },
  ];

  const subscriptionStatusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    { value: "expired", label: "Expired" },
    { value: "pending", label: "Pending" },
    { value: "merged", label: "Merged" },
  ];

  return (<div className="petrolbunk-management-page">
          <Container fluid>
            <div className='page-title-main'>
              <h5 className='page-title'>Petrol Bunk Management</h5>
              <p className='page-info'>Manage petrol bunk details, cameras, and assigned admins.</p>
            </div> 
            <div className='page-content-main'>
              {isDeleted && <SuccessToolbar message="🎉 Petrol Bunk have been deleted successfully." />}
              {customerror && <ErrorToolbar message={`⚠️ ${customerror}`} />}
              
              <div className='filter-action-main'>
                    <Row className="mb-2">
                        <Col xs={12} sm={10} md={10}>
                            <div className='input-filter-action'>
                                <input type="text" id="customSearch" name='customSearch' placeholder="Search by bunk name & location" value={customSearch} onChange={handleSearchChange} />
                            </div>
                        </Col>
                        {/* <Col xs={4} sm={1} md={1} className='select-filter-actiontopdiv apply-mgtp-mbl'>
                            <div className='select-filter-action'>
                                <div className='select-filter-btn' onClick={() => setShowFilder(true)} ><span className='select-filter-txt'>Filter</span><span className='select-filter-icon'><img src={filterIcon} alt='filterIcon' /></span></div>
                                {(showFilder) && <div className='select-filter-list'>
                                      <div className='select-filter-listinner'>
                                          <div className='select-filterlist-title'>
                                                  <h5 className='select-filterlist-titletxt'>Filters</h5>
                                                  <span className='select-filterlist-icon' onClick={() => setShowFilder(false)}><i className="bx bx-x"></i></span>
                                          </div>
                                          <div className='select-filterlist-main'>
                                            <div className='select-filterlist-row'>
                                                  <label>Bunk Status</label>
                                                  <Select
                                                    name="planType"
                                                    options={subscriptionStatusOptions}
                                                    value={formData.planType}
                                                    onChange={handleChange}
                                                    placeholder={"Select Plan Type"}
                                                    className='custom-react-sltbx'
                                                    classNamePrefix="custom-react-sltbx"
                                                  />
                                            </div>
                                             <div className='select-filterlist-row'>
                                                  <label>State</label>
                                                  <Select
                                                    name="planType"
                                                    options={subscriptionStatusOptions}
                                                    value={formData.planType}
                                                    onChange={handleChange}
                                                    placeholder={"Select Plan Type"}
                                                    className='custom-react-sltbx'
                                                    classNamePrefix="custom-react-sltbx"
                                                  />
                                            </div>
                                            <div className='select-filterlist-row'>
                                                  <label>District</label>
                                                  <Select
                                                    name="planType"
                                                    options={subscriptionStatusOptions}
                                                    value={formData.planType}
                                                    onChange={handleChange}
                                                    placeholder={"Select Plan Type"}
                                                    className='custom-react-sltbx'
                                                    classNamePrefix="custom-react-sltbx"
                                                  />
                                            </div> 
                                            <div className='select-filterlist-row'>
                                              <label>Area</label>
                                              <Select
                                                name="subscriptionStatus"
                                                options={subscriptionStatusOptions}
                                                onChange={handleChange}
                                                value={formData.subscriptionStatus}
                                                placeholder="Select Subscription Status"
                                                className="select2 custom-react-sltbx"
                                                classNamePrefix="custom-react-sltbx"
                                              />
                                            </div>  
                                          </div>
                                          <div className='d-flex justify-content-center gap-2 select-filterlist-action'>
                                              <Button variant="secondary custom-reset-btncls" type="button">
                                                Reset
                                              </Button>
                                              <Button variant="secondary custom-apply-btncls" type="button">
                                                Apply
                                              </Button>
                                          </div>
                                      </div>
                                </div>}
                            </div>
                        </Col> */}
                        <Col xs={12} sm={2} md={2} className='apply-mgtp-mbl'>
                            <div className='create-record-action text-end'>
                                <Button type="button" className="btn btn-primary add-btn-flteract" onClick={() => handleAddBunk()}>
                                  <FaPlus /> Add Petrol Bunk
                                </Button>
                            </div>
                        </Col>
                    </Row>
              </div>

              <Row>
                <Col xs="12">
                      <div className='tablelist-maindiv'>
                          <ServerTable
                            key={tableKey}
                            apiUrlTxt="entities"
                            columns={columns}
                            customParams={''}
                            showSearch={false}
                            showAddBtn={false}
                            addBtn={{ label: '', url: `` }}
                            srlNumbr={false}
                            customSearch={true}
                            customSearchTxt={customSearch}
                          />
                      </div>
                
                </Col>
              </Row>

              <ConfirmModal
                show={showConfirm}
                onHide={handleCancel}
                onConfirm={handleConfirm}
                title={<span className='confirm-mdltitle-iconmain'><i className="bx bx-trash"></i></span>}
                message="Are you sure you want to delete this Petrol Bunk?"
                btntxt="Delete"
              />            

            </div>   
          </Container>
        </div>);
}
